import { Box } from '@material-ui/core';

import { LiveIndicator } from '@/components/shared/components/LiveIndicator';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useScreen } from '@/hooks/useScreen';

import { Font } from '../../../shared/components/Font';
import { Text } from '../../../shared/components/Text';

interface SectionTitlesProps {
  pageTitleTextId: string | undefined;
  pageSubtitleTextId: string | undefined;
}

export const PageTitles = ({ pageTitleTextId, pageSubtitleTextId }: SectionTitlesProps) => {
  const {
    state: { customTitleTId, customSubtitleTId, liveState },
  } = usePageContext();
  const { sm, isMobile } = useScreen();

  const pageTitleId = customTitleTId || pageTitleTextId;
  const pageSubtitleId = customSubtitleTId || pageSubtitleTextId;

  if (!pageTitleId && !pageSubtitleId) {
    return null;
  }

  const titleMarginBottom = pageSubtitleId && isMobile ? '0px' : '25px';

  // Stretched to the row height (minus the bottom margin of what it sits next to) so the dot is centred on it.
  const liveIndicator = (marginBottom: string) =>
    liveState !== 'closed' && (
      <Box display={'flex'} alignItems={'center'} alignSelf={'stretch'} style={{ marginLeft: '16px', marginBottom }}>
        <LiveIndicator state={liveState} />
      </Box>
    );

  return (
    <Box
      display={'flex'}
      flexDirection={isMobile ? 'column' : 'row'}
      alignItems={'baseline'}
      minHeight={sm ? 60 : 30}
      // position={'sticky'}
      // top={'100px'}
      // zIndex={11}
      // bgcolor={'common.white'}
    >
      {pageTitleId && (
        // On mobile the subtitle wraps below the title, so the dot stays on the title's line
        <Box display={'flex'}>
          <Font variant={'h1'} color={'title'} style={{ minHeight: '50px', marginBottom: titleMarginBottom }}>
            <Text originalTextId tId={pageTitleId} />
          </Font>
          {isMobile && liveIndicator(titleMarginBottom)}
        </Box>
      )}
      {pageSubtitleId && (
        <Font
          variant={'h4'}
          color={'title'}
          style={{ minHeight: '50px', marginBottom: '25px', paddingLeft: isMobile ? '0px' : '12px' }}
        >
          (<Text originalTextId tId={pageSubtitleId} />)
        </Font>
      )}
      {(!isMobile || !pageTitleId) && liveIndicator('28px')}
    </Box>
  );
};
